import React from 'react'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useState } from 'react'
import { AuthContext } from '../../context/AuthContext'
import { useContext } from 'react'
import { useParams } from 'react-router'
import ENDPOINT from '../../context/EndPoint'
import axios from 'axios'
import DeleteIcon from '@mui/icons-material/Delete';
import SecurityHeaders from '../../context/SecurityHeaders'
import AdminDeleteQuiz from '../../actions/quiz/AdminDeleteQuiz'
import DetectDevice from '../../context/DetectDevice'
import { useDispatch } from 'react-redux'

const MockTestsManagement = ({ test_type }) => {
  const dispatch = useDispatch()
  const device = DetectDevice()
  const params = useParams();
  const course_url = params.course_url
  const { user } = useContext(AuthContext)

  const [info, setinfo] = useState(null);

  const getQuizzes = async () => {
    dispatch({ type: 'LOADING' });
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("course_url", course_url);
    data.append("test_type", test_type);
    try {
      const res = await axios.post(ENDPOINT + "mock-test-categories.php", data, SecurityHeaders);
      if (res?.data) {
        if (res.data.status === "success") {
          dispatch({ type: 'DONE_LOADING' });
          setposts(res.data.data);
        } else {
          dispatch({ type: 'ERROR', payload: res.data.message || 'Failed to fetch quizzes' });
        }
      } else {
        dispatch({ type: 'ERROR', payload: 'Invalid response format' });
      }
    } catch (error) {
      dispatch({ type: 'ERROR', payload: error.message || 'An error occurred while fetching quizzes' });
    }
  };

  const [account, setaccount] = useState(null);
  const [role, setrole] = useState(null);
  const [question, setquestion] = useState(null)
  const [option1, setoption1] = useState(null)
  const [option2, setoption2] = useState(null)
  const [option3, setoption3] = useState(null)
  const [option4, setoption4] = useState(null)
  const [answer, setanswer] = useState(null)
  const [posts, setposts] = useState(null)
  const [allcomments, setallcomments] = useState(null)

  const AddQuiz = async (e) => {
    dispatch({ type: 'LOADING' });
    try {
      e.preventDefault();
      const data = new FormData();
      data.append("title", title);
      data.append("description", description);
      data.append("test_code", testcode);
      data.append("duration", duration);
      data.append("test_type", test_type);
      data.append("course_url", course_url);
      data.append("demo_certificate", certificateimage);
      data.append("session", user.SessionId);
      if (cover) data.append("cover", cover);

      const res = await axios.post(ENDPOINT + "add-test-topic.php", data, SecurityHeaders);
      if (res) {
        if (res.data.status === "success") {
          dispatch({ type: 'DONE_LOADING' });
          getQuizzes();
        } else {
          dispatch({ type: 'ERROR', payload: res.data.message || 'Failed to add quiz' });
        }
      }
    } catch (error) {
      dispatch({ type: 'ERROR', payload: error.message || 'An error occurred while adding quiz' });
    }
  };

  const DeleteQuiz = async ({ quiz_id }) => {
    const res = await AdminDeleteQuiz({ payload: { user: user.SessionId, quiz_id: quiz_id } })
    if (res.status === "success") { getQuizzes() }
  }

  const [answer1, setanswer1] = useState(false)
  const [answer2, setanswer2] = useState(false)
  const [answer3, setanswer3] = useState(false)
  const [answer4, setanswer4] = useState(false)

  useEffect(() => {
    if (answer1) { setanswer("option1"); setanswer2(false); setanswer3(false); setanswer4(false) }
    if (answer2) { setanswer("option2"); setanswer1(false); setanswer3(false); setanswer4(false) }
    if (answer3) { setanswer("option3"); setanswer1(false); setanswer2(false); setanswer4(false) }
    if (answer4) { setanswer("option4"); setanswer1(false); setanswer2(false); setanswer3(false) }
  }, [answer1, answer2, answer3, answer4])

  useEffect(() => {
    getQuizzes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const DeleteTestTopic = async ({ exam_code }) => {
    dispatch({ type: 'LOADING' });
    const data = new FormData();
    data.append("course_url", course_url);
    data.append("test_code", exam_code);
    try {
      const res = await axios.post(ENDPOINT + "delete-test-topic.php", data, SecurityHeaders);
      if (res?.data) {
        if (res.data.status === "success") {
          dispatch({ type: 'DONE_LOADING' });
          getQuizzes();
        } else {
          dispatch({ type: 'ERROR', payload: res.data.message || 'Failed to delete test topic' });
        }
      } else {
        dispatch({ type: 'ERROR', payload: 'Invalid response format' });
      }
    } catch (error) {
      dispatch({ type: 'ERROR', payload: error.message || 'An error occurred while deleting test topic' });
    }
  };

  const [certificateimage, setcertificateimage] = useState(null)
  const [cover, setcover] = useState(null)
  const [title, settitle] = useState(null)
  const [description, setdescription] = useState(null)
  const [duration, setduration] = useState(null)
  const [testcode, settestcode] = useState(null)

  const isCert = test_type === "course-certification";

  // ---- clean design tokens ------------------------------------------
  const C = { ink: "#1f2937", blue: "#2563eb", muted: "#8a909c" };
  const card = { background: "#fff", borderRadius: 12, border: "1px solid #e8eaed", boxShadow: "0 1px 2px rgba(16,24,40,.04)" };
  const label = { display: "block", fontSize: 12.5, fontWeight: 600, color: "#5b616e", marginBottom: 6 };

  return (
    <>
      <style>{`
        .mt-input{outline:none;border:1px solid #d9dde3;border-radius:8px;padding:10px 12px;font-size:14px;width:100%;background:#fff;color:#1f2937;}
        .mt-input:focus{border-color:#2563eb;box-shadow:0 0 0 3px rgba(37,99,235,.12);}
        .mt-btn{transition:opacity .15s ease;} .mt-btn:hover:not(:disabled){opacity:.9;}
      `}</style>

      <div style={{ background: "#f7f8fa", padding: device === "mobile" ? "16px 12px" : "22px" }}>
        <div className="mb-3">
          <h4 style={{ margin: 0, fontWeight: 700, color: C.ink }}>{isCert ? "Certification Exam Papers" : "Mock Test Papers"}</h4>
          <p style={{ margin: "4px 0 0", fontSize: 13.5, color: C.muted }}>Create papers and add questions for <b>{course_url}</b>.</p>
        </div>

        <div className="row g-4">
          {/* papers list */}
          <div className="col-12 col-lg-7">
            <div style={{ ...card, padding: 18 }}>
              <h6 style={{ margin: 0, fontWeight: 700, color: C.ink, marginBottom: 14 }}>
                Papers <span style={{ color: C.muted, fontWeight: 500 }}>({posts ? posts.length : 0})</span>
              </h6>
              {posts && posts.length ? (
                posts.map((quiz) => (
                  <div key={quiz.test_code} style={{ border: "1px solid #eef1f6", borderRadius: 10, padding: "12px 14px", marginBottom: 10, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                    <Link to={"/" + test_type + "/" + course_url + "/test-code/" + quiz.test_code} style={{ textDecoration: "none", flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, color: C.ink, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {quiz.title || "Untitled paper"}
                      </div>
                      <div style={{ fontSize: 12.5, color: C.muted }}>
                        #{quiz.test_code} · {quiz.duration ? quiz.duration + " mins" : "—"} · tap to add questions →
                      </div>
                    </Link>
                    <button type="button" className="mt-btn" title="Delete paper" onClick={() => DeleteTestTopic({ exam_code: quiz.test_code })} style={{ border: "none", background: "transparent", color: "#b42318", cursor: "pointer", padding: 4, lineHeight: 1 }}>
                      <DeleteIcon style={{ fontSize: 19 }} />
                    </button>
                  </div>
                ))
              ) : (
                <p style={{ color: C.muted, margin: 0 }}>No papers yet — add one on the right.</p>
              )}
            </div>
          </div>

          {/* add paper */}
          <div className="col-12 col-lg-5">
            <div style={{ ...card, padding: 18 }}>
              <h6 style={{ margin: 0, fontWeight: 700, color: C.ink, marginBottom: 14 }}>{isCert ? "Add Certification Paper" : "Add Test Paper"}</h6>
              <form onSubmit={(e) => AddQuiz(e)}>
                {isCert && (
                  <>
                    <label style={label}>Demo Certificate</label>
                    <input className="mt-input" onChange={(e) => settitle(e.target.value)} required />
                  </>
                )}

                <label style={{ ...label, marginTop: isCert ? 14 : 0 }}>Title</label>
                <input className="mt-input" onChange={(e) => settitle(e.target.value)} placeholder="e.g. Java Basics — Set 1" required />

                <label style={{ ...label, marginTop: 14 }}>Description</label>
                <input className="mt-input" onChange={(e) => setdescription(e.target.value)} placeholder="Short description" required />

                <div className="d-flex" style={{ gap: 12, marginTop: 14 }}>
                  <div style={{ flex: 1 }}>
                    <label style={label}>Duration (mins)</label>
                    <input className="mt-input" type="number" onChange={(e) => setduration(e.target.value)} placeholder="e.g. 30" required />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={label}>Test code</label>
                    <input className="mt-input" onChange={(e) => settestcode(e.target.value)} placeholder="e.g. 1234" required />
                  </div>
                </div>

                <label style={{ ...label, marginTop: 14 }}>Cover image <span style={{ color: C.muted, fontWeight: 500 }}>(shown on the website)</span></label>
                <input type="file" accept="image/*" className="mt-input" style={{ padding: 8 }} onChange={(e) => setcover(e.target.files[0])} />
                {cover ? <img src={URL.createObjectURL(cover)} alt="cover preview" style={{ maxWidth: "100%", marginTop: 8, borderRadius: 8, border: "1px solid #eee" }} /> : null}

                <button type="submit" className="mt-btn" style={{ width: "100%", marginTop: 16, border: "none", color: "#fff", background: C.blue, borderRadius: 8, padding: "12px", fontSize: 14.5, fontWeight: 600, cursor: "pointer" }}>
                  {isCert ? "Add Certification Paper" : "Add Test Paper"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MockTestsManagement
